import commentModalTemplate from './addInfoModalTemplate.html';

const commentModal = {

    bindings: {
        label: '@',
        onCommentEntered: '&',
        comment:'@'
    },

    template: `  <button type="button" ng-click="$ctrl.openModal();" class="button button-picton-blue button-outline button-font icon-right ion-plus margin--top-xs">
                        {{ $ctrl.label | translate }}
                    </button>`,

    controller: function ($state, $scope, $ionicModal, $ionicLoading) {
        this.$state = $state;


        this.modal = $ionicModal.fromTemplate(commentModalTemplate, {
            scope: $scope
        });

        this.$onInit = () => {
            this.label = this.label;
            this.comment = this.comment;
        }

        this.openModal = () => {
            this.modal.show();
        };

        this.closeModal = () => {
            this.modal.hide();
        };

        this.addComment = () => {
            this.onCommentEntered({"comment":this.comment});
            this.modal.hide();
        };

    }
};

export default commentModal;


/** WEBPACK FOOTER **
 ** ./src/app/directives/addInfoModal/addInfoModal.js
 **/